import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";
import * as QS from "querystring";
import * as React from "react";
import StripeCheckout, { Token } from "react-stripe-checkout";

import {API, Button, Text, TextInput} from "../components";

import CoffeeCheckoutDialog, {CheckoutStatus} from "./CoffeeCheckoutDialog";
import CoffeeSelection from "./CoffeeSelection";

type ClassNames = "container" | "paypal";

export const COFFEE_PRICE = 5;
const styles = (theme: Theme): StyleRules<ClassNames> => ({
  container: {
    
  },
  paypal: {
    marginLeft: theme.spacing.unit,
    color: theme.palette.primary[500],
    textDecoration: "none",
    fontSize: theme.typography.caption.fontSize
  }
});

interface ICoffeeCheckoutProps extends WithStyles<typeof styles>  {
  noop?: boolean
}

interface ICoffeeCheckoutState {
  selectionValue: string;
  selection: number;
  name: string;
  message: string;
  checkout: CheckoutStatus;
  accessKey: string | null;
  email: string | null;
}

class CoffeeCheckout extends React.PureComponent<ICoffeeCheckoutProps, ICoffeeCheckoutState> {

  public state = {
    selection: 1,
    name: "",
    message: "",
    selectionValue: "1",
    checkout: "none" as "none",
    accessKey: null,
    email: null
  };

  private stripe: React.RefObject<StripeCheckout> = React.createRef();
  private key: string = API.isProduction
  ?
      "pk_live_2ruvnlX2Eqa1yYxXjufnGiKA"
  :
      "pk_test_IgNcZsyRG4FkepgyUGEBXAn4";

  public setName = (name: string) => this.setState({ name });
  public setMessage = (message: string) => this.setState({ message });
  public setSelection = (selectionValue: string, selection: number) => this.setState({ selectionValue, selection });
  public submit = (e: React.ChangeEvent<HTMLFormElement>) => {
    (this.stripe.current as any).onClick();
    e.preventDefault();
  };

  public onClose = () => this.setState({ checkout: "none", message: "", name: "" });
  public onCloseError = () => this.setState({ checkout: "none" });

  public render() {
    const {onClose, onCloseError} = this;
    const {classes} = this.props;
    const {selection, selectionValue, checkout, name, message, accessKey, email} = this.state;
    return (
      <form className={classes.container}>
        <Text variant="title2">Buy me a coffee</Text>
        <CoffeeSelection onChange={this.setSelection} {...{selection, selectionValue}} />
        <TextInput
          placeholder="Name (optional)"
          onChange={this.setName}
          value={name}
        />
        <TextInput
          placeholder="Message (optional)"
          multiline={true}
          rows={4}
          value={message}
          onChange={this.setMessage}
        />
        <div>
          <StripeCheckout
            ref={this.stripe}
            ComponentClass="span"
            token={this.token}
            stripeKey={this.key}
            amount={selection * COFFEE_PRICE * 100}
            currency="USD"
          >
            <Button onClick={this.submit} type="submit" disabled={selection <= 0} primary={true}>
              ${(selection <= 0 ? 0 : selection) * COFFEE_PRICE} Support
            </Button>
          </StripeCheckout>
          <a
            href="https://www.paypal.me/wcandillon"
            target="_blank"
            className={classes.paypal}
          >or using paypal</a>
        </div>
        <CoffeeCheckoutDialog {...{checkout, onClose, onCloseError, accessKey, email}} />
      </form>
    );
  }

  private token = async (token: Token) => {
    this.setState({
      checkout: "loading"
    });
    const {selection, name, message} = this.state;
    const {endpoint} = API;
    const testMode = !API.isProduction;
    const fn = "buyMeACoffee";
    const query = {
      testMode,
      amount: selection * COFFEE_PRICE * 100,
      name,
      message
    };
    const url = `${endpoint}${fn}?${QS.stringify(query)}`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(token),
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    });
    if (response.status === 200) {
      const data = await response.json();
      const {key: accessKey} = data;
      this.setState({
        checkout: "success",
        accessKey,
        email: token.email
      });
    } else {
      this.setState({
        checkout: "error"
      });
    }
  }
}

export default withStyles(styles)(CoffeeCheckout);


// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/CoffeeCheckout.tsx